import { http } from '../../../helpers';
import {
    detectImageContentTypeFromBuffer,
    validateImageBinaryResource,
} from '../../../helpers/binaryResourceValidators';

export const CLEAR_ALIGNER_TEMPLATE_NAME = 'Clear Aligner';
export const CLEAR_ALIGNER_THUMBNAIL_TYPES = ['side2', 'front', 'side1', 'top', 'back', 'bottom'];

const clearAlignerThumbnailLabels = {
    side2: 'Side 2',
    front: 'Front',
    side1: 'Side 1',
    top: 'Top',
    back: 'Back',
    bottom: 'Bottom',
};

export const validateThumbnailResource = validateImageBinaryResource;

function getImageContentType(response) {
    const headerType = String(response?.headers?.['content-type'] || '')
        .toLowerCase();
    const detectedContentType = detectImageContentTypeFromBuffer(response?.data);

    if (detectedContentType) {
        return detectedContentType;
    }

    if (headerType.startsWith('image/')) {
        return headerType;
    }

    return '';
}

function getBlobDataUrl(response) {
    const contentType = getImageContentType(response);

    if (!contentType) {
        throw new Error('Thumbnail response was not a recognized image.');
    }

    const image = btoa(new Uint8Array(response.data).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        '',
    ));

    return `data:${contentType};base64,${image}`;
}

export function buildThumbnailTypeUrl(url, type) {
    if (!url || !type) {
        return '';
    }

    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}type=${encodeURIComponent(type)}`;
}

export function loadThumbnailFromCandidates(thumbnailUrlCandidates) {
    const tryNextCandidate = (candidateIndex) => {
        if (candidateIndex >= thumbnailUrlCandidates.length) {
            return Promise.reject(new Error('No thumbnail candidates succeeded.'));
        }

        return http.getBlob(thumbnailUrlCandidates[candidateIndex], 'image/*')
            .then((response) => getBlobDataUrl(response))
            .catch(() => tryNextCandidate(candidateIndex + 1));
    };

    return tryNextCandidate(0);
}

export function prioritizeThumbnailUrlCandidates(thumbnailUrlCandidates, preferredUrl) {
    const nextThumbnailUrlCandidates = Array.isArray(thumbnailUrlCandidates)
        ? thumbnailUrlCandidates.filter(Boolean)
        : [];

    if (!preferredUrl) {
        return Array.from(new Set(nextThumbnailUrlCandidates));
    }

    return Array.from(new Set([
        preferredUrl,
        ...nextThumbnailUrlCandidates,
    ]));
}

export function getClearAlignerThumbnailLabel(type) {
    return clearAlignerThumbnailLabels[type] || type;
}

export function buildClearAlignerThumbnailItems(caseThumbnailUrl) {
    return CLEAR_ALIGNER_THUMBNAIL_TYPES
        .map((type) => ({
            id: `clear-aligner-thumbnail-${type}`,
            label: getClearAlignerThumbnailLabel(type),
            thumbnailUrlCandidates: [buildThumbnailTypeUrl(caseThumbnailUrl, type)].filter(Boolean),
            type,
            typeLabel: 'Thumbnail',
        }))
        .filter((thumbnail) => thumbnail.thumbnailUrlCandidates.length > 0);
}
